export const FirstFactorRoute = "/";
export const AuthenticatedRoute = "/authenticated";

export const SecondFactorRoute = "/2fa";
export const SecondFactorU2FRoute = "/2fa/security-key";
export const SecondFactorTOTPRoute = "/2fa/one-time-password";
export const SecondFactorPushRoute = "/2fa/push-notification";

export const ResetPasswordStep1Route = "/reset-password/step1";
export const ResetPasswordStep2Route = "/reset-password/step2";
export const RegisterSecurityKeyRoute = "/security-key/register";
export const RegisterOneTimePasswordRoute = "/one-time-password/register";
export const LogoutRoute = "/logout";
